export default __webpack_public_path__ + "static/media/logooc.cda50888.png";